package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.PermissionType
import kotlinx.serialization.Serializable

@Serializable
enum class UserPermissionContent(private val literal: String) : PermissionType {
	发布内容("发布内容"),
	评论内容("评论内容"),
	发布中医常见问题("发布中医常见问题"),
	发布学习指引("发布学习指引");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "user_permission_content"}
	override fun getLiteral(): String {return literal}
}
